import styled, {css} from 'styled-components'

export const StyledInfoWrapper = styled.div`
    ${({theme}) => css`
        display: grid;
        grid-template-columns: auto 1fr;
        gap: ${theme.spacing * 5}px;

        @media (max-width: 768px) {
            grid-template-columns: 1fr;
        }
    `}
`

export const StyledInfoTitle = styled.span`
    ${({theme}) => css`
        ${theme.typography.textSm};
        color: ${theme.palette.neutral['500']};
    `}
`

export const StyledInfoDescription = styled.span`
    ${({theme}) => css`
        ${theme.typography.textMd};
        color: ${theme.palette.neutral['900']};
        font-weight: 600;
        user-select: none;
        transition: opacity 0.2s;
    `}
`
